module.exports = __webpack_public_path__ + "static/img/cocina_19.e9e9ab34.png";